import { Anchor, Paragraph, Text } from '@zillow/constellation-10';

import { useGetUser } from '../../hooks/queries/user';

import { paths as zrmPaths } from '../../utils/zrmPathsManifest';

import { inheritColorClass } from '../../styles';

const POST_FIRST_LISTING_URL_QUERY = '?postingPath=true';

const SignInCTA = () => {
  const {
    data: { loggedIn: isLoggedIn, isInitialMultiFactorAuthenticationRequired },
  } = useGetUser();

  const isPartiallyAuthenticated = isLoggedIn || isInitialMultiFactorAuthenticationRequired;

  if (isPartiallyAuthenticated) {
    return null;
  }

  return (
    <Paragraph textStyle="body-sm" css={{ height: '500', lineHeight: '20px', marginTop: '500' }}>
      <Text>Already have an account? </Text>
      <Anchor
        className={inheritColorClass}
        href={zrmPaths.zrmSignInPage(`${zrmPaths.propertiesPage}${POST_FIRST_LISTING_URL_QUERY}`) || ''}
      >
        <strong>Sign in</strong>
      </Anchor>
    </Paragraph>
  );
};

export default SignInCTA;
